import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SolicitudComponent } from './public/components/solicitud/solicitud.component';
import { AutorizacionComponent } from './public/components/autorizacion/autorizacion.component';
import { ConsultaComponent } from './public/components/consulta/consulta.component';
import { ConsultaRuntComponent } from './public/components/consulta-runt/consulta-runt.component';

import { DetalleComponent } from './core/components/detalle/detalle.component';
import { DetalleRuntComponent } from './core/components/detalle-runt/detalle-runt.component';

import { PaginaErrorComponent } from './shared/components/pagina-error/pagina-error.component';

import { AutenticacionGuard } from './shared/services/autenticacion-guard.service';
import { AutenticacionRuntGuard } from './shared/services/autenticacion-runt-guard.service';
import { IpGuard } from './shared/services/ip-guard.service';

import { ReCaptchaResolver } from './shared/services/re-captcha-resolver.service';
import { DetalleSolicitudResolver } from './core/services/detalle-solicitud-resolver.service';
import { DetalleSolicitudInternoResolver } from './core/services/detalle-solicitud-interno-resolver.service';

const appRoutes: Routes = [
  { path: '', redirectTo: '/solicitud', pathMatch: 'full' },
  { path: 'solicitud', component: SolicitudComponent, resolve: { siteKey: ReCaptchaResolver } },
  { path: 'autorizacion/:codigo', component: AutorizacionComponent },
  { path: 'consulta', component: ConsultaComponent, resolve: { siteKey: ReCaptchaResolver } },
  { path: 'detalle/:id', component: DetalleComponent, canActivate: [AutenticacionGuard], resolve: { detalleSolicitud: DetalleSolicitudResolver } },
  { path: 'consulta-runt', component: ConsultaRuntComponent,  canActivate: [IpGuard], resolve: { siteKey: ReCaptchaResolver } },
  { path: 'detalle-runt/:id', component: DetalleRuntComponent, canActivate: [AutenticacionRuntGuard], resolve: { detalleSolicitud: DetalleSolicitudInternoResolver } },
  { path: 'pagina-error', component: PaginaErrorComponent },
  { path: '**', redirectTo: '/pagina-error' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/app-routing.module.ts